module.exports = __webpack_public_path__ + "img/logo.66c5a83e.png";